module.exports = __webpack_public_path__ + "static/media/1.8e3290eb.png";